
  import { mapState } from 'vuex'

  import Icon from '../Icon'

  export default {
    name: 'AccordionItem',
    components: {
      Icon,
    },
    data() {
      return {
        showContent: '',
      }
    },
    props: {
      data: {
        type: Object,
        default: () => {}
      },
      type: {
        type: String,
        default: ''
      },
      order: {
        type: Number | String,
        default: ''
      },
    },
    mounted() {
      if (this.data && this.data.starts_open) {
        this.showContent = this.data.heading
      }
    },
    computed: {
      ...mapState({
        billing: state => state.checkout.billing,
      }),
      isMobile() {
        return this.$mq == 'sm' || this.$mq == 'md' ? true : false
      },
      arrowClasses() {
        if (this.isMobile) {
          return 'black'
        }
        return 'black large'
      },
      enabled() {
        if (this.type) {
          return this.data && this.data.visible && this.billing.find(b => b.type === this.type) ? true : false
        }

        return this.data && this.data.visible
      },
      dataSectionNumber() {
        if (this.order) {
          return this.order
        }

        if (this.data.section_number) {
          return this.data.section_number
        }

        return null
      }
    },
    methods: {
      toggle() {
        if (this.showContent) {
          this.showContent = ''
        } else {
          this.showContent = this.data.heading
        }
      }
    }
  }
